module.exports = __webpack_public_path__ + "static/img/stimulusGamesBlue.d0a247e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stimulusGamesBlue.png
// module id = 2r+l
// module chunks = 1